












































































































































import { Component, Vue } from 'vue-property-decorator';
import { Reference, SideboardGalleryImage } from '@/models/SideboardGallery';
import ImagePopup from '@/components/Inspiration/ImagePopup.vue';

// import OutletContactForm from '@/components/SideboardGallery/OutletContactForm.vue';

@Component({
    components: {
        ImagePopup
        // OutletContactForm
    }
})
export default class References extends Vue {
    protected outlets!: Reference[];
    protected showSideboard: boolean = false;
    protected selectedOutlet!: Reference;
    protected showSelectedOutlet: boolean = false;
    protected lastClickedNode = null;
    protected selectedImageIndex: number = 0;
    private bodyEl: HTMLBodyElement | null = null;
    
    constructor() {
        super();
        this.outlets = JSON.parse(this.$attrs['data-outlets']);
        this.$attrs['data-outlets'] = '';
        this.bodyEl = document.querySelector('body');
    }

    destroyed() {
        document.removeEventListener('mousedown', this.clickHandler);
    }
    private mounted() {
        document.addEventListener('mousedown', this.clickHandler);
        
    }

    private clickHandler(e: any) {
        this.lastClickedNode = e.target;
        const sideBoard = document.querySelector('.sideboard-gallery__sideboard');
        const modalWindow = document.getElementById('modals-container');

        if (sideBoard && !sideBoard.contains(this.lastClickedNode) && (!modalWindow || !modalWindow.children.length)) {
            this.closeSideboard();
        }
    }

    private showImage(imageUrl: string) {
        this.$modal.show(
            ImagePopup,
            {
                imageUrl
            },
            {
                adaptive: false,
                height: '90%',
                width: '90%',
                maxWidth: 1500,
                scrollable: false
            }
        );
    }

    private closeSideboard() {
        if(this.bodyEl) {
            this.bodyEl.style.overflow = '';
        }

        this.removeBodyClass();
        this.showSideboard = false;
        this.showSelectedOutlet = false;
        this.selectedOutlet = {} as Reference;
    }

    private openSideboard(outlet: Reference) {
        if(this.bodyEl) {
            this.bodyEl.style.overflow = 'hidden';
        }

        this.addBodyClass();
        this.showSideboard = true;
        this.showSelectedOutlet = false;
        this.selectedOutlet = outlet;
        this.showSelectedOutlet = true;
    }

    private scroll(adjust: number) {
        const element = document.querySelector('#scroller');
        let elementWidth: number = 400 * adjust;
        let elementMargin: number = 20;

        if (element != null && element.childNodes != null && element.childNodes.length > 0) {
            // @ts-ignore
            const li = element.childNodes[0];

            if (li != null) {
                // @ts-ignore
                const style = window.getComputedStyle(li);
                elementMargin = Number(style.paddingRight.replace('px', ''));
            }

            // @ts-ignore
            elementWidth = (element.offsetWidth + elementMargin * 2) * adjust;

            if (adjust === 0) {
                element.scrollLeft = 0;
            } else {
                element.scrollTo({
                    left: element.scrollLeft + elementWidth,
                    behavior: 'smooth'
                });
            }
        }
    }

    private scrollTo(id: any) {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        }
    }

    private removeBodyClass() {
        const body = document.body;

        if (body.classList.contains('body-slided')) {
            body.classList.remove('body-slided');
        }
    }
    private addBodyClass() {
        const body = document.body;
        if (!body.classList.contains('body-slided')) {
            body.classList.add('body-slided');
        }
    }

    private selectedImage(index: number) {
        const element = document.getElementById('image-' + index);
        if (element) {
            const elementContainer = document.querySelector('#scroller');
            const offsetLeft = element.offsetLeft;
            if (elementContainer) {
                elementContainer.scrollTo({
                    left: offsetLeft
                });
            }
        }
        this.scrollTo('sideboard-top');
    }

    private changeImage(n: number) {
        const imagesLength = this.selectedOutlet.Images.length;
        this.selectedImageIndex = (((this.selectedImageIndex + n) % imagesLength) + imagesLength) % imagesLength;
    }

    private openDropdown(e: any) {
        const dropdown = e.currentTarget;

        if (!dropdown.classList.contains('open')) {
            this.closeDropdown();
            dropdown.classList.add('open');
        } else if (dropdown.classList.contains('open')) {
            this.closeDropdown();
        }
    }
    private closeDropdown() {
        const dropdowns = document.querySelectorAll('.social-item');
        dropdowns.forEach((dropdown: any) => {
            dropdown.classList.remove('open');
        });
    }
    private copyLink(e: any) {
        const linkElem = e.currentTarget;
        const url = linkElem.getAttribute('url');
        const el = document.createElement('textarea');
        el.value = url;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
}
